// Enrich i18n at runtime to keep phase 2 strings without rewriting entire JSON files.
import i18n from "@/i18n";

const GL = {
  nav_geoportal: "Xeoportal",
  nav_esg: "ESG",
  loading_data: "Cargando datos…",
  empty_state: "Sen datos suficientes nesta ventá",
  empty_state_sub: "Cando o operador amplíe o alcance, este bloque poboarase automaticamente.",
  demo_badge: "",
  scope_notice: "Datos non dispoñibles nesta ventá — pendente de ampliación de scope da conta de servizo. Ver INTEGRATION_GAPS.md",
  updated: "Actualizado",
  updated_seconds_ago: "hai {{n}} s",
  status_new: "Nova",
  status_triage: "En triaxe",
  status_assigned: "Asignada",
  status_route: "En ruta",
  status_resolved: "Resolta",
  status_closed: "Pechada",
  status_unassigned: "Sen asignar",
  overflow: "Desborde",
  observation: "Observación",
  detection: "Detección",
  provisional: "Provisional",
  official: "Oficial",
  category_E: "Ambiental",
  category_S: "Social",
  category_G: "Gobernanza",
  no_value: "Sen valor",
  view_detail: "Ver detalle",
  close: "Pechar",
  download: "Descargar",
  fleet_empty_notice: "Aínda non hai vehículos con telemetría activa integrada. Os datos aparecerán automaticamente cando o provedor GPS conecte a frota.",
  concello: "Concello",
  all_concellos: "Todos os concellos",
  vehicle: "Vehículo",
  no_vehicle: "Sen vehículo seleccionado",
  date_range: "Rango de datas",
  last_24h: "Últimas 24 h",
  last_7d: "Últimos 7 días",
  last_30d: "Últimos 30 días",
  status: "Estado",
  show: "Amosar",
  show_all: "Todo",
  show_overflow: "Só desbordes",
  show_observations: "Só observacións",
  layers: "Capas",
  layer_detections: "Deteccións",
  layer_overflow: "Desbordes",
  layer_observations: "Observacións",
  layer_vehicles: "Vehículos",
  layer_concellos: "Concellos",
  layer_sigeus_points: "Puntos de recollida",
  sigeus_popup_view_detail: "Ver detalle en Contedores",
  sigeus_layer_count: "{{n}} de {{total}} puntos siGEUS",
  basemap: "Base cartográfica",
  basemap_carto: "CARTO Light",
  basemap_esri: "ESRI Topográfico",
  photo_blur_notice: "Foto anonimizada — persoas / matrículas cubertas.",
  formula: "Fórmula",
  data_source: "Fonte de datos",
  last_update: "Última actualización",
  traceability: "Trazabilidade",
  variation_previous: "vs. período anterior",
  data_health: "Estado das fontes de datos",
  last_detections: "Últimas deteccións",
  view_geoportal: "Abrir Xeoportal",
  view_esg: "Abrir ESG",
  esg_title: "Panel ESG",
  esg_subtitle: "Indicadores institucionais Ambiental · Social · Gobernanza",
  geoportal_title: "Xeoportal territorial",
  geoportal_subtitle: "Deteccións, observacións e frota en tempo case-real",
  detections_by_concello: "Deteccións por concello",
  monthly_evolution: "Evolución mensual",
  concellos_comparative: "Comparativa por concello",
  no_polygons_notice: "Superficies oficiais dos concellos non dispoñibles nesta versión — mostramos os centros coas circunferencias representativas.",
  refresh: "Actualizar",
  build_phase: "",
  sidebar_footprint: "Pegada",
  sidebar_admin: "Admin",
};

const ES = {
  nav_geoportal: "Geoportal",
  nav_esg: "ESG",
  loading_data: "Cargando datos…",
  empty_state: "Sin datos suficientes en esta ventana",
  empty_state_sub: "Cuando el operador amplíe el alcance, este bloque se poblará automáticamente.",
  demo_badge: "",
  scope_notice: "Datos no disponibles en esta ventana — pendiente de ampliación de scope de la cuenta de servicio. Ver INTEGRATION_GAPS.md",
  updated: "Actualizado",
  updated_seconds_ago: "hace {{n}} s",
  status_new: "Nueva",
  status_triage: "En triaje",
  status_assigned: "Asignada",
  status_route: "En ruta",
  status_resolved: "Resuelta",
  status_closed: "Cerrada",
  status_unassigned: "Sin asignar",
  overflow: "Desbordamiento",
  observation: "Observación",
  detection: "Detección",
  provisional: "Provisional",
  official: "Oficial",
  category_E: "Ambiental",
  category_S: "Social",
  category_G: "Gobernanza",
  no_value: "Sin valor",
  view_detail: "Ver detalle",
  close: "Cerrar",
  download: "Descargar",
  fleet_empty_notice: "Aún no hay vehículos con telemetría activa integrada. Los datos aparecerán automáticamente cuando el proveedor GPS conecte la flota.",
  concello: "Municipio",
  all_concellos: "Todos los municipios",
  vehicle: "Vehículo",
  no_vehicle: "Sin vehículo seleccionado",
  date_range: "Rango de fechas",
  last_24h: "Últimas 24 h",
  last_7d: "Últimos 7 días",
  last_30d: "Últimos 30 días",
  status: "Estado",
  show: "Mostrar",
  show_all: "Todo",
  show_overflow: "Solo desbordamientos",
  show_observations: "Solo observaciones",
  layers: "Capas",
  layer_detections: "Detecciones",
  layer_overflow: "Desbordamientos",
  layer_observations: "Observaciones",
  layer_vehicles: "Vehículos",
  layer_concellos: "Municipios",
  layer_sigeus_points: "Puntos de recogida",
  sigeus_popup_view_detail: "Ver detalle en Contenedores",
  sigeus_layer_count: "{{n}} de {{total}} puntos siGEUS",
  basemap: "Base cartográfica",
  basemap_carto: "CARTO Light",
  basemap_esri: "ESRI Topográfico",
  photo_blur_notice: "Foto anonimizada — personas / matrículas cubiertas.",
  formula: "Fórmula",
  data_source: "Fuente de datos",
  last_update: "Última actualización",
  traceability: "Trazabilidad",
  variation_previous: "vs. período anterior",
  data_health: "Estado de las fuentes de datos",
  last_detections: "Últimas detecciones",
  view_geoportal: "Abrir Geoportal",
  view_esg: "Abrir ESG",
  esg_title: "Panel ESG",
  esg_subtitle: "Indicadores institucionales Ambiental · Social · Gobernanza",
  geoportal_title: "Geoportal territorial",
  geoportal_subtitle: "Detecciones, observaciones y flota en tiempo casi real",
  detections_by_concello: "Detecciones por municipio",
  monthly_evolution: "Evolución mensual",
  concellos_comparative: "Comparativa por municipio",
  no_polygons_notice: "Superficies oficiales de los municipios no disponibles en esta versión — mostramos los centros con las circunferencias representativas.",
  refresh: "Actualizar",
  build_phase: "",
  sidebar_footprint: "Huella",
  sidebar_admin: "Admin",
};

// Merge into existing 'common' namespace at runtime so existing translations keep working.
i18n.addResourceBundle("gl", "common", { fase2: GL }, true, true);
i18n.addResourceBundle("es", "common", { fase2: ES }, true, true);

export default {};
